import React from "react";
import { SimpleHeader } from "./SimpleHeader";

interface FreeFieldProfileHeaderProps {
  profile: server.dto.FreeFieldProfileSmall
}

export const FreeFieldProfileHeader = ({ profile }: FreeFieldProfileHeaderProps) =>
  <SimpleHeader title={profile.title} isDeleted={false} />;
